import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { FileService } from 'modules/file';
import FileImageSection from 'modules/file/components/FileImageSection';
import FileImageUpload from 'modules/file/components/FileImageUpload';
import { isVideo } from 'modules/file/helpers';
import PropTypes from 'prop-types';

import { UploadManager } from '@hotmart/club-files-ui';

class TabImage extends Component {
  static propTypes = {
    entity: PropTypes.string,
    beforeSend: PropTypes.func,
    multiple: PropTypes.bool,
    medias: PropTypes.array
  };

  static defaultProps = {
    multiple: true
  };

  get item() {
    return this.props.medias[0];
  }

  render() {
    const { entity, beforeSend, multiple } = this.props;

    if (this.item && !isVideo(this.item)) {
      return <FileImageSection {...this.item} entityType={entity} slim />;
    } else {
      return (
        <FileImageUpload
          entityType={entity}
          beforeSend={beforeSend}
          multiple={multiple}
          onCancelUpload={FileService.delete}
        />
      );
    }
  }
}

const hocUploadManager = withRouter(({ match, entityType, ...props }) => (
  <UploadManager
    {...props}
    entity={`${entityType}_IMG`}
    entityId={match.params.id}
    itemsProp="medias"
    onError={FileService.handleFileException}
  >
    <TabImage />
  </UploadManager>
));

export default hocUploadManager;
